import styled from '@app/styled';
import { color, typography } from '@app/theme';

export const GitCompleteText = styled.span`
    ${typography('custom.description')}
    color: ${color('custom.content.secondary')}
`;

export const ExampleImageWrapper = styled.figure`
    position: relative;
    width: 100%;
    padding-top: 40%;
`;

export const ExampleImage = styled.img`
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
`;
